import { IsNotEmpty, IsUUID } from 'class-validator';

import { FormAttributesRequest } from '../../types';
import { NOT_EMPTY_OPTIONS } from '../../constants';

export class SignPepDto {
  @IsNotEmpty({
    ...NOT_EMPTY_OPTIONS,
    groups: ['form'],
  })
  @IsUUID(undefined, {
    groups: ['form'],
  })
  eventId: string;

  @IsNotEmpty({
    ...NOT_EMPTY_OPTIONS,
    groups: ['form'],
  })
  @IsUUID(undefined, {
    groups: ['form'],
  })
  nodeId: string;

  attributes?: FormAttributesRequest;
}
